export default "https://cdn-static.gokick.com/assets/38a17193d7f2ad0638d84ec7199a8f76eb0c19ef/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";